import materialTabService from "@services/requests/material-tab.service";
import { setConcreteStrength, setConcreteConditions, setMasonryType } from '@reducers/selectors/material/actions';
import { standardList } from "./../../../app.values";

export const SET_BONDS_RESPONSE = 'SET_BONDS_RESPONSE';
export const SET_CONDITIONS_RESPONSE = 'SET_CONDITIONS_RESPONSE';
export const SET_STRENGTHS_RESPONSE = 'SET_STRENGTHS_RESPONSE';
export const SET_STRENGTH_VALUE = 'SET_STRENGTH_VALUE';
export const SET_SPINNER = 'SET_SPINNER';
export const SET_MASONRY_TYPES_RESPONSE = 'SET_MASONRY_TYPES_RESPONSE';
export const RESET_WEB_MATERIAL_STATE = 'RESET_WEB_MATERIAL_STATE';
export const SET_WEB_MATERIAL_STATE = 'SET_WEB_MATERIAL_STATE';

/*
  Action creators
 */
export function initMaterialTab (){
  return (dispatch, getState) => {
      const state = getState();
      if (Number(state.main.localization.designStandard) !== standardList['Masonry']) {
        materialTabService.getConcreteStrength().then(res => {
          if (!res.Status){
            var isChanged = false;
            if (res.length === state.webServices.material.strengths.length){
              res.forEach((item, index)=> {
                if (item.RunName !== state.webServices.material.strengths[index].RunName)
                  isChanged = true;
              });
            }
            else {
              isChanged = true;
            }
    
            if (isChanged){
              dispatch({type: SET_STRENGTHS_RESPONSE, value: res});
              if (res.length > 0){
                var defaultValue = res[0]['InternalName'];
                if ((Number(getState().main.localization.designStandard) === standardList['EU'] ||
                    Number(getState().main.localization.designStandard) === standardList['AnnexC']) && res.length > 1)
                  defaultValue = res[1]["InternalName"]; // C25/30
  
                dispatch(setConcreteStrength(defaultValue));
                dispatch(getConcreteStrengthValue(defaultValue));
              }
            }
          }
        });
        materialTabService.getConcreteConditions().then(res => {
          if (res && res.length){
            dispatch({type: SET_CONDITIONS_RESPONSE, value: res});
            if (res[0] && res[0].InternalName && 
              state.selectors.material[state.main.appType].concrete.conditions &&
              !res.find((cond) => cond.InternalName === state.selectors.material[state.main.appType].concrete.conditions))
              dispatch(setConcreteConditions(res[0].InternalName));
          }
        });
        materialTabService.getBondConditions().then(res => {
          dispatch({type: SET_BONDS_RESPONSE, value: res});
        });
      }
  };
}

export function getConcreteStrengthValue (strength){
  return async (dispatch) => {
    await materialTabService.getConcreteStrengthValue(strength).then(res => {
      dispatch(setConcreteStrengthValue(res));
    });
  };
}

export function setConcreteStrengthValue (strength){
  return async (dispatch) => {
    dispatch({type: SET_STRENGTH_VALUE, value: strength});
  };
}

export function setSpinner (isPending) {
  return (dispatch) => {
    dispatch({ type: SET_SPINNER, value: isPending });
  };
}

export function getMasonryMaterials () {
  return (dispatch) => {
    materialTabService.getMasonryMaterials().then(async res => {
      if (res && res[0]){
        dispatch({ type: SET_MASONRY_TYPES_RESPONSE, value: res });
        dispatch(setMasonryType(res[0].InternalName));
      }
    });
  };
}

export function resetWebMaterialState() {
  return (dispatch) => {
    dispatch({ type: RESET_WEB_MATERIAL_STATE });
  };
}

export function setWebMaterialState(state) {
  return (dispatch) => {
    dispatch({ type: SET_WEB_MATERIAL_STATE, state });
  };
}



// WEBPACK FOOTER //
// ./src/reducers/web-services/material/actions.js